module.exports = __webpack_public_path__ + "img/poney_pikachu.16334844.png";